import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=4065748a&scoped=true&lang=pug&"
import script from "./Success.vue?vue&type=script&lang=js&"
export * from "./Success.vue?vue&type=script&lang=js&"
import style0 from "./Success.scss?vue&type=style&index=0&id=4065748a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4065748a",
  null
  
)

export default component.exports